export default "__VITE_ASSET__528431d5__"